import connectBoostLogo from "assets/images/connectBoostLogo.webp";
import acronis from "assets/images/integration/acronis.png";
import automate from "assets/images/integration/automate.png";
import datto from "assets/images/integration/dattoLogo.png";
import hudu from "assets/images/integration/hudu.png";
import itglue from "assets/images/integration/it-glue.png";
import level from "assets/images/integration/level.png";
import nable from "assets/images/integration/nable.png";
import ninja from "assets/images/integration/ninja.png";
import nSight from "assets/images/integration/nsight.png";
import quickbooks from "assets/images/integration/quickbooks.png";
import xero from "assets/images/integration/xero.png";
import zoho from "assets/images/integration/zoho.png";
import logMeInLogo from "assets/images/logMeInLogo.webp";
import passportalLogo from "assets/images/passportalLogo.webp";
import pax8Logo from "assets/images/integration/pax8Logo.png";
import scalePadLogo from "assets/images/scalePadLogo.webp";
import screenConnectLogo from "assets/images/screenConnectLogo.webp";
import splashtopLogo from "assets/images/splashtopLogo.webp";
import stripeLogo from "assets/images/stripeLogo.webp";
import superOpsLogo from "assets/images/superOpsLogo.webp";
import syncroLogo from "assets/images/syncroLogo.webp";
import teamViewerLogo from "assets/images/teamViewerLogo.webp";
import veeamLogo from "assets/images/veeamLogo.webp";
import waveLogo from "assets/images/waveLogo.webp";

export type IntegrationListType = {
  label: string;
  value: string;
  description: string;
  logo: string; // or specify the type of the logo, e.g. string, React.ReactNode, etc.
  isActive: boolean;
  isAvailable: boolean;
  deactivationTagline: string;
  menuItems: boolean | false; // or just boolean, depending on the desired type
  isConnected: boolean;
  documentation?: string;
  sourceId?: string;
  // Connect-only integrations (no enable/disable sync concept, e.g. Pax8, Hudu)
  // hide the on-card toggle/bell — prevents showing a dead/disabled control.
  hideSyncToggle?: boolean;
  // Gradient "beta" tag beside the card label, shown connected or not.
  isBeta?: boolean;
  // Lottie "NEW" badge, top-right. Only while disconnected.
  isNew?: boolean;
};

export const INTEGRATION_SOURCE_IDS = {
  NCENTRAL: "9ef2d0e7-815b-4d02-895c-9a8cc1b0105f",
  NINJA: "45a0b835-6f81-476a-8ccb-015db363be91",
  LEVEL: "dac04dfe-0b49-4014-9833-d0bd94235cdb",
  DATTO: "7f3a8b2c-4d91-4e5f-b6c7-1a9d3e7f8c2b",
};

export const integrationsList = [
  {
    type: "Remote Monitoring & Management",
    children: [
      {
        label: "N-able N-central",
        value: "ncentral",
        description:
          "Effortlessly integrate N-central with the PSA platform, streamlining alert management into ticket resolution",
        logo: nable,
        isActive: false,
        isAvailable: true,
        deactivationTagline:
          "To do so, remove the PSA integration in N-able (Administration > PSA integration > Configure > Remove)",
        menuItems: true,
        documentation:
          "https://support.deskday.com/en/articles/9109705-how-to-integrate-with-n-able-n-central",
        sourceId: INTEGRATION_SOURCE_IDS.NCENTRAL,
        menuOptions: [
          { name: "Configure", value: "configure", type: "ncentral" },
        ],
      },
      {
        label: "NinjaOne RMM",
        value: "ninjaOne",
        description:
          "Effortlessly integrates NinjaOne RMM, streamlining alert management and ticket resolution within DeskDay.",
        logo: ninja,
        isActive: false,
        isAvailable: true,
        deactivationTagline:
          "Are you sure to deactivate the NinjaOne integration on this account?",
        menuItems: true,
        menuOptions: [
          { name: "Configure", value: "configure", type: "ninjaOne" },
          { name: "Disconnect Ninja One", value: "deactivate", type: "ninjaOne" },
        ],
        documentation:
          "https://support.deskday.com/en/articles/9749682-how-to-integrate-with-ninjaone",
        sourceId: INTEGRATION_SOURCE_IDS.NINJA,
      },
      {
        label: "Datto RMM",
        value: "datto",
        description:
          "Connect DeskDay with Datto to streamline alert management and ticket resolution by directly accessing devices within tickets on DeskDay",
        logo: datto,
        isActive: false,
        isAvailable: true,
        deactivationTagline:
          "Are you sure to deactivate the Datto integration on this account?",
        menuItems: true,
        menuOptions: [
          { name: "Configure", value: "configure", type: "datto" },
          { name: "Disconnect Datto", value: "deactivate", type: "datto" },
        ],
        documentation:
          "https://support.deskday.com/en/articles/13543935-how-to-integrate-with-datto-rmm",
        sourceId: INTEGRATION_SOURCE_IDS.DATTO,
      },
      {
        label: "Connectwise Automate",
        value: "Connectwise-automate",
        description:
          "Our PSA platform seamlessly manages and resolves alerts into tickets through ConnectWise Automate integration.",
        logo: automate,
        isActive: false,
        isAvailable: false,
        deactivationTagline: "",
        menuItems: false,
      },
      {
        label: "Level RMM",
        value: "level",
        description:
          "Level RMM now integrates with DeskDay PSA for automated ticket creation and seamless IT service management workflows.",
        logo: level,
        isActive: false,
        isAvailable: true,
        deactivationTagline:
          "Are you sure to deactivate the Level RMM integration on this account?",
        menuItems: true,
        menuOptions: [
          { name: "Configure", value: "configure", type: "level" },
          { name: "Disconnect Level", value: "deactivate", type: "level" },
        ],
        documentation:
          "https://support.deskday.com/en/articles/11737626-how-to-integrate-with-level-rmm",
        sourceId: INTEGRATION_SOURCE_IDS.LEVEL,
      },
      {
        label: "N-sight RMM",
        value: "n-sight",
        description:
          "N-sight tool seamlessly integrates with PSA platform for alert-to-ticket transition and resolution.",
        logo: nSight,
        isActive: false,
        isAvailable: false,
        deactivationTagline: "",
        menuItems: false,
      },
      {
        label: "Syncro",
        value: "syncro",
        description:
          "Seamlessly integrates with Syncro RMM, simplifying alert handling and ticket management directly within DeskDay.",
        logo: syncroLogo,
        isActive: false,
        isAvailable: false,
        deactivationTagline: "",
        menuItems: false,
      },
      {
        label: "SuperOps",
        value: "superops",
        description:
          "Seamlessly integrates with SuperOps RMM, streamlining alert management and ticket resolution within DeskDay.",
        logo: superOpsLogo,
        isActive: false,
        isAvailable: false,
        deactivationTagline: "",
        menuItems: false,
      },
    ],
  },
  {
    type: "Accounting",
    children: [
      {
        label: "QuickBooks",
        value: "qb",
        description:
          "Integrate DeskDay with QuickBooks to keep invoices, payments, customers, and taxes in sync for streamlined billing workflows and accurate accounting.",
        logo: quickbooks,
        isActive: false,
        isAvailable: true,
        deactivationTagline:
          "Are you sure to deactivate the QuickBooks integration on this account?",
        menuItems: true,
        menuOptions: [
          { name: "Configure", value: "configure", type: "qb" },
          { name: "Disconnect Quickbooks", value: "deactivate", type: "qb" },
        ],
        documentation:
          "https://support.deskday.com/en/articles/9924598-how-to-integrate-with-quickbooks",
      },
      {
        label: "Xero",
        value: "xero",
        description:
          "Connect DeskDay with Xero to sync invoices, payments, and taxes for accurate accounting and billing workflows.",
        logo: xero,
        isActive: false,
        isAvailable: true,
        deactivationTagline:
          "Are you sure to deactivate the Xero integration on this account?",
        menuItems: true,
        menuOptions: [
          { name: "Configure", value: "configure", type: "xero" },
          { name: "Disconnect Xero", value: "deactivate", type: "xero" },
        ],
        documentation:
          "https://support.deskday.com/en/articles/13385749-how-to-integrate-with-xero",
      },
      {
        label: "ZOHO books",
        value: "zoho",
        description:
          "Seamlessly integrate with Zoho Books to sync invoices, payments, and client data for streamlined financial management and operations.",
        logo: zoho,
        isActive: false,
        isAvailable: false,
        deactivationTagline: "",
        menuItems: false,
      },
      {
        label: "ScalePad",
        value: "scalepad",
        description:
          "Effortlessly integrates with ScalePad to sync asset details, warranties, and reports for enhanced financial insights and management.",
        logo: scalePadLogo,
        isActive: false,
        isAvailable: false,
        deactivationTagline: "",
        menuItems: false,
      },
      {
        label: "Wave",
        value: "wave",
        description:
          "Effortlessly integrates with Wave to sync invoices, payments, and client data for streamlined financial management and operations.",
        logo: waveLogo,
        isActive: false,
        isAvailable: false,
        deactivationTagline: "",
        menuItems: false,
      },
    ],
  },
  {
    type: "Documentation Management",
    children: [
      {
        label: "Hudu",
        value: "hudu",
        description:
          "Effortlessly integrate with Hudu to sync documentation, passwords, and client data for streamlined management and operations.",
        logo: hudu,
        isActive: false,
        isAvailable: true,
        deactivationTagline: "",
        menuItems: true,
        hideSyncToggle: true,
        menuOptions: [
          { name: "Configure", value: "configure", type: "hudu" },
          { name: "Disconnect Hudu", value: "deactivate", type: "hudu" },
        ],
        documentation:
          "https://support.deskday.com/en/articles/11904765-how-to-integrate-with-hudu",
      },
      {
        label: "IT-Glue",
        value: "it-glue",
        description:
          "Effortlessly integrate with IT Glue to sync documentation, passwords, and client data for streamlined management and operations.",
        logo: itglue,
        isActive: false,
        isAvailable: false,
        deactivationTagline: "",
        menuItems: false,
      },
      {
        label: "Passportal",
        value: "passportal",
        description:
          "Easily manage client credentials with Passportal, automating password updates and enhancing security with role-based access.",
        logo: passportalLogo,
        isActive: false,
        isAvailable: false,
        deactivationTagline: "",
        menuItems: false,
      },
    ],
  },
  {
    type: "Distribution",
    children: [
      {
        label: "Pax8",
        value: "pax8",
        description:
          "Integrate with Pax8 to streamline cloud service distribution, simplify billing, and enhance operational efficiency within DeskDay.",
        logo: pax8Logo,
        isActive: false,
        isAvailable: true,
        isNew: true,
        deactivationTagline: "",
        menuItems: true,
        hideSyncToggle: true,
        menuOptions: [
          { name: "Configure", value: "configure", type: "pax8" },
          { name: "Disconnect", value: "deactivate", type: "pax8" },
          { name: "Update Credentials", value: "reconnect", type: "pax8" },
          { name: "Sync now", value: "sync_now", type: "pax8" },
        ],
        documentation:
          "https://support.deskday.com/en/articles/18173089-connect-and-manage-pax8-in-deskday",
      },
    ],
  },
  {
    type: "BDR",
    children: [
      {
        label: "Acronis",
        value: "acronis",
        description:
          "Ensure the security of your clients' data by integrating Acronis with DeskDay to manage them effectively.",
        logo: acronis,
        isActive: false,
        isAvailable: false,
        deactivationTagline: "",
        menuItems: false,
      },
      {
        label: "Veeam",
        value: "veeam",
        description:
          "Integrate with Veeam to ensure reliable backup, seamless disaster recovery, and efficient data management within DeskDay.",
        logo: veeamLogo,
        isActive: false,
        isAvailable: false,
        deactivationTagline: "",
        menuItems: false,
      },
    ],
  },
  {
    type: "Remote Control",
    children: [
      {
        label: "ScreenConnect",
        value: "screen-connect",
        description:
          "Connect with ScreenConnect to deliver streamlined remote support and effective issue resolution directly through DeskDay.",
        logo: screenConnectLogo,
        isActive: false,
        isAvailable: false,
        deactivationTagline: "",
        menuItems: false,
      },
      {
        label: "Splashtop",
        value: "splashtop",
        description:
          "Connect with Splashtop to provide efficient remote support and seamless issue resolution directly through DeskDay.",
        logo: splashtopLogo,
        isActive: false,
        isAvailable: false,
        deactivationTagline: "",
        menuItems: false,
      },
      {
        label: "TeamViewer",
        value: "team-viewer",
        description:
          "Integrate TeamViewer to enable quick and reliable remote access, ensuring smooth issue resolution through DeskDay.",
        logo: teamViewerLogo,
        isActive: false,
        isAvailable: false,
        deactivationTagline: "",
        menuItems: false,
      },
      {
        label: "LogMeIn",
        value: "log-me-in",
        description:
          "Link with LogMeIn to deliver robust remote support, enhancing troubleshooting and resolution processes within DeskDay.",
        logo: logMeInLogo,
        isActive: false,
        isAvailable: false,
        deactivationTagline: "",
        menuItems: false,
      },
    ],
  },
  {
    type: "Payments",
    children: [
      {
        label: "Stripe",
        value: "stripe",
        description:
          "Connect Stripe to collect invoice payments and sync payment status with DeskDay billing.",
        logo: stripeLogo,
        isActive: false,
        isAvailable: true,
        isNew: true,
        deactivationTagline:
          "Are you sure to disconnect the Stripe integration on this account?",
        menuItems: false,
        menuOptions: [
          { name: "Disconnect", value: "deactivate", type: "stripe" },
        ],
      },
      {
        label: "Connect Boost",
        value: "connect-boost",
        description:
          "Integrate with Connect Boost to enable reliable payment processing and simplified financial tracking, all within DeskDay.",
        logo: connectBoostLogo,
        isActive: false,
        isAvailable: false,
        deactivationTagline: "",
        menuItems: false,
      },
    ],
  },
  // {
  //   type: "PSA",
  //   children: [
  //     {
  //       label: "Autotask",
  //       value: "autotask",
  //       description:
  //         "By integrating Autotask into our PSA platform, we enable bi-directional synchronization of service items and any associated updates.",
  //       logo: autotask,
  //       isActive: false,
  //       isAvailable: false,
  //       deactivationTagline: "",
  //       menuItems: false,
  //     },
  //     {
  //       label: "Connectwise Manage",
  //       value: "connectwise-manage",
  //       description:
  //         "By linking ConnectWise Manage with our PSA platform, we ensure two-way synchronization of service items and updates.",
  //       logo: connectwise,
  //       isActive: false,
  //       isAvailable: false,
  //       deactivationTagline: "",
  //       menuItems: false,
  //     },
  //   ],
  // },
];
